import { ThemeProvider as StyledThemeProvider } from "styled-components";

const theme = {
  flexboxgrid: {
    // Defaults
    gridSize: 12, // columns
    gutterWidth: 1, // rem
    outerMargin: 0, // rem
    mediaQuery: "only screen",
    container: {
      sm: 72, // rem
      md: 96, // rem
      lg: 120, // rem
    },
    breakpoints: {
      xs: 0, // em
      sm: 54, // em
      md: 72, // em
      lg: 96, // em
    },
  },
};

const ThemeProvider = ({ children }) => {
  return <StyledThemeProvider theme={theme}>{children}</StyledThemeProvider>;
};

export default ThemeProvider;
